export type DataClientMode = 'mock' | 'api'

export function getDataClientMode(): DataClientMode {
  return import.meta.env.VITE_DATA_CLIENT_MODE === 'api' ? 'api' : 'mock'
}

export function isApiDataClientMode() {
  return getDataClientMode() === 'api'
}

export function getProductionDataClientModeError() {
  if (!import.meta.env.PROD) return null
  if (import.meta.env.VITE_DATA_CLIENT_MODE === 'api') return null
  return {
    code: 'production_data_client_mode_invalid',
    message:
      'Production 必須使用 API / D1 資料模式。請確認建置環境設定 VITE_DATA_CLIENT_MODE=api。',
  }
}

export function shouldAllowApiModeMockFallback() {
  return !import.meta.env.PROD
}
